import { SszRegionUpdateInput } from '@libs/types/src/list/input-type/ssz-region.update-input';
import { SszRegionCreateInput } from '@libs/types/src/list/input-type/ssz-region.create-input';
import { SszRegionGridObject, SszRegionObject } from '@libs/types/src/list/object-type/ssz-region.object';
import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { GqlServiceV2 } from '../../modules/content/service/gql.service-v2';
import { filterFrag } from '../types/filter.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { sszRegionFrag } from '../types/ssz-region.types';

@Injectable({ providedIn: 'root' })
export class ListSszRegionService extends GqlServiceV2 {

    public getListSszRegions(input: GridInput, frag = sszRegionFrag) {
        return this.query<SszRegionGridObject>(
            `
                query($input: GridInput!) {
                    sszRegion {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createListSszRegion(input: SszRegionCreateInput, frag = sszRegionFrag) {
        return this.mutate<SszRegionObject>(
            `
                mutation($input: SszRegionCreateInput!) {
                    sszRegion {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateListSszRegion(input: SszRegionUpdateInput, frag = sszRegionFrag) {
        return this.mutate<SszRegionObject>(
            `
                mutation($input: SszRegionUpdateInput!) {
                    sszRegion {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteListSszRegion(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    sszRegion {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
